import { useMemo } from "react";

import { selectActions } from "@/features/app/appSlice";

import { useAppSelector } from "@/app/hooks";
import { ActionType } from "@/features/config/types";
import { ActionsCustomizableModal } from "./modals/ActionsCustomizableModal";

const useActions = () => {
  // Redux
  const actions = useAppSelector(selectActions);

  const modals = useMemo(() => {
    return actions
      .filter((tAct) => tAct.action === ActionType.MODAL)
      .map((modal) => {
        return (
          <ActionsCustomizableModal
            key={`${modal.triggerOptions.tag}_current-step_${modal.trigger}_${Date.now()}`}
            title={modal.actionOptions.modal?.title}
            description={modal.actionOptions.modal?.description}
          />
        );
      });
  }, [actions]);
  return { modals };
};

export default useActions;
